// Generated by purs version 0.14.4
import * as $foreign from "./foreign.js";
import * as Unsafe_Coerce from "../Unsafe.Coerce/index.js";
var RIO = function (x) {
    return x;
};
var functorRIO = {
    map: $foreign.mapImpl
};
var applyRIO = {
    apply: $foreign.applyImpl,
    Functor0: function () {
        return functorRIO;
    }
};
var bindRIO = {
    bind: $foreign.bindImpl,
    Apply0: function () {
        return applyRIO;
    }
};
var applicativeRIO = {
    pure: $foreign.pureImpl,
    Apply0: function () {
        return applyRIO;
    }
};
var monadRIO = {
    Applicative0: function () {
        return applicativeRIO;
    },
    Bind1: function () {
        return bindRIO;
    }
};
var monadAskRIO = {
    ask: $foreign.askImpl,
    Monad0: function () {
        return monadRIO;
    }
};
var monadEffectRIO = {
    liftEffect: Unsafe_Coerce.unsafeCoerce,
    Monad0: function () {
        return monadRIO;
    }
};
export {
    rio,
    runRIO,
    local
} from "./foreign.js";
export {
    RIO,
    functorRIO,
    applyRIO,
    applicativeRIO,
    bindRIO,
    monadRIO,
    monadAskRIO,
    monadEffectRIO
};
//# sourceMappingURL=index.js.map
